module.exports = __webpack_public_path__ + "static/media/ask-an-expert.7fb639fb.png";